import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { normalizarValorOrdenacao } from '../../../shared/helpers/ordenacao-tabela.helper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';

import { HeaderComponent } from '../../../shared/components/header/header.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { AlertCardComponent } from '../../../shared/components/alert-card/alert-card.component';
import { AbntPipe } from '../../../shared/pipes/abnt.pipe';

import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { NaturezaMovimentacaoEnum } from '../../../shared/enums/financas/natureza-movimentacao.enum';
import { TipoMatchConciliacaoEnum } from '../../../shared/enums/financas/tipo-match-conciliacao.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MaskService } from '../../../shared/services/mask.service';
import { CustomDateAdapter } from '../../../shared/services/custom-date-adapter';
import { LimitDateValidator } from '../../../shared/validators/limit-date.validator';
import { ConciliacaoBancariaService } from '../../../shared/services/apis/financas/conciliacao-bancaria.service';
import { ExtratoBancarioContaItem } from '../../../shared/services/responses/financas/extrato-bancario-contas.response';
import {
  ExtratoBancarioConciliadoItem,
  MovimentacaoConciliadaItem,
} from '../../../shared/services/responses/financas/get-lancamentos-conciliados.response';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { DesconciliarDialogComponent } from './dialogs/desconciliar-dialog/desconciliar-dialog.component';

export enum PeriodoConciliadosEnum {
  Hoje = 1,
  DaSemana = 2,
  DoMes = 3,
  Ultimos30Dias = 4,
  DoIntervalo = 5,
}

export interface ConciliadoDisplayRow {
  data: ExtratoBancarioConciliadoItem;
  isChild: boolean;
  childData?: MovimentacaoConciliadaItem;
}

@Component({
  selector: 'app-conciliacao-bancaria-conciliados',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HeaderComponent,
    EmptyListComponent,
    LoadingBoxDefaultListComponent,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTooltipModule,
    MatMenuModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSortModule,
    AbntPipe,
    AlertCardComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
  templateUrl: './conciliacao-bancaria-conciliados.component.html',
  styleUrls: ['./conciliacao-bancaria-conciliados.component.css'],
})
export class ConciliacaoBancariaConciliadosComponent implements OnInit {
  moduloEnum = ModuloEnum.Financas;
  funcionalidadeEnum = FuncionalidadeEnum.Financas_ConciliacaoBancaria;
  naturezaEnum = NaturezaMovimentacaoEnum;
  tipoMatchEnum = TipoMatchConciliacaoEnum;
  PeriodoConciliadosEnum = PeriodoConciliadosEnum;

  idContaFinanceira!: number;
  nomeBanco = '';
  agencia = '';
  numeroConta = '';
  descricaoContaFinanceira = '';

  _contas: ExtratoBancarioContaItem[] = [];
  isLoadingContas = false;

  isLoading = false;
  _temMais = false;
  _paginaAtual = 0;
  totalConciliado = 0;
  pesquisa = '';

  // Período
  model!: FormGroup;
  periodoSelecionado: PeriodoConciliadosEnum = PeriodoConciliadosEnum.DoMes;
  limiteMaxDias = 365;
  private periodoSelecionadoAplicado: PeriodoConciliadosEnum = PeriodoConciliadosEnum.DoMes;
  private periodoIntervaloDeAplicado: Date | null = null;
  private periodoIntervaloAteAplicado: Date | null = null;
  private periodoMenuFoiAplicado = false;

  @ViewChild('periodoMenuTrigger') periodoMenuTrigger?: MatMenuTrigger;

  displayedColumns: string[] = ['select', 'data', 'descricao', 'tipo', 'valor', 'actions'];
  _dataSource = new MatTableDataSource<ExtratoBancarioConciliadoItem>([]);
  _flatDataSource = new MatTableDataSource<ConciliadoDisplayRow>([]);
  expandedElement: ExtratoBancarioConciliadoItem | null = null;
  selection = new SelectionModel<ExtratoBancarioConciliadoItem>(true, []);

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this._flatDataSource.sort = sort;
    this._flatDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'data': return normalizarValorOrdenacao(item.data.dataTransacao);
        case 'descricao': return normalizarValorOrdenacao(item.data.memo);
        case 'valor': return normalizarValorOrdenacao(item.data.valor);
        default: return normalizarValorOrdenacao((item as any)[property]);
      }
    };
  }


  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private conciliacaoBancariaService: ConciliacaoBancariaService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.idContaFinanceira = Number(this.route.snapshot.paramMap.get('idContaFinanceira'));

    const hoje = new Date();
    const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

    this.model = this.fb.group({
      dataDe: [primeiroDia, Validators.required],
      dataAte: [hoje, Validators.required],
    }, { validators: LimitDateValidator.rangeLimit(2) });

    this.salvarPeriodoAplicado();
    this.carregarContas();
    this.carregarConciliados(true);
  }

  private carregarContas(): void {
    this.isLoadingContas = true;
    this.conciliacaoBancariaService.getContas().subscribe({
      next: (res) => {
        this.isLoadingContas = false;
        if (!res.isError) this._contas = res.contas;
      },
      error: () => { this.isLoadingContas = false; },
    });
  }

  onContaChange(idContaFinanceira: number): void {
    this.idContaFinanceira = idContaFinanceira;
    this.router.navigate(
      ['/financas/conciliacao-bancaria/conciliados', idContaFinanceira],
      { replaceUrl: true }
    );
    this.carregarConciliados(true);
  }

  carregarConciliados(resetar = true): void {
    if (resetar) {
      this._paginaAtual = 0;
      this.expandedElement = null;
      this.selection.clear();
    }
    this.isLoading = true;

    const formValue = this.model.getRawValue();
    const dataInicio = formValue.dataDe ? this.formatDate(new Date(formValue.dataDe)) : null;
    const dataFim = formValue.dataAte ? this.formatDate(new Date(formValue.dataAte)) : null;

    this.conciliacaoBancariaService.getLancamentosConciliados({
      idContaFinanceira: this.idContaFinanceira,
      dataInicio,
      dataFim,
      pesquisa: this.pesquisa.trim() || null,
      pageIndex: this._paginaAtual,
    }).subscribe({
      next: (res) => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          return;
        }
        this.nomeBanco = res.nomeBanco;
        this.agencia = res.agencia;
        this.numeroConta = res.numeroConta;
        this.descricaoContaFinanceira = res.descricaoContaFinanceira;
        this._temMais = res.temMais;

        if (resetar) {
          this._dataSource.data = res.itens;
          this.totalConciliado = res.itens.reduce((acc, i) => acc + Math.abs(i.valor), 0);
        } else {
          this._dataSource.data = [...this._dataSource.data, ...res.itens];
          this.totalConciliado += res.itens.reduce((acc, i) => acc + Math.abs(i.valor), 0);
        }
        this.reconstruirFlatDataSource();
      },
      error: (err) => {
        this.isLoading = false;
        this.alertService.show('Erro', err.message, AlertType.error);
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual++;
    this.carregarConciliados(false);
  }

  toggleRow(row: ConciliadoDisplayRow): void {
    if (row.isChild) return;
    this.expandedElement = this.expandedElement === row.data ? null : row.data;
    this.reconstruirFlatDataSource();
  }

  reconstruirFlatDataSource(): void {
    const flat: ConciliadoDisplayRow[] = [];
    for (const item of this._dataSource.data) {
      flat.push({ data: item, isChild: false });
      if (this.expandedElement === item) {
        for (const mov of item.movimentacoes) {
          flat.push({ data: item, isChild: true, childData: mov });
        }
      }
    }

    this._flatDataSource.data = flat;
  }

  labelTipoMatch(tipoMatch: number): string {
    if (tipoMatch === TipoMatchConciliacaoEnum.ContaPagar) return 'Conta a Pagar';
    if (tipoMatch === TipoMatchConciliacaoEnum.ContaReceber) return 'Conta a Receber';
    return 'Movimentação';
  }

  classeTipoMatch(tipoMatch: number): string {
    if (tipoMatch === TipoMatchConciliacaoEnum.ContaPagar) return 'badge-amarelo';
    if (tipoMatch === TipoMatchConciliacaoEnum.ContaReceber) return 'badge-verde';
    return 'badge-azul';
  }

  isAllSelected(): boolean {
    return this.selection.selected.length === this._dataSource.data.length;
  }

  toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this._dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  checkboxLabel(row?: ExtratoBancarioConciliadoItem): string {
    if (!row) return `${this.isAllSelected() ? 'deselecionar' : 'selecionar'} todos`;
    return `${this.selection.isSelected(row) ? 'deselecionar' : 'selecionar'} linha`;
  }

  labelConta(conta: ExtratoBancarioContaItem): string {
    return `${conta.nomeBanco} — ${conta.descricao} (Ag. ${conta.agencia})`;
  }

  voltar(): void {
    this.router.navigate(['/financas/conciliacao-bancaria/lancamentos', this.idContaFinanceira]);
  }

  onDateInput(event: Event): void {
    MaskService.onDateInput(event);
  }

  // ── Período ────────────────────────────────────────────────────────────────

  get periodoLabel(): string {
    switch (this.periodoSelecionado) {
      case PeriodoConciliadosEnum.Hoje: return 'hoje';
      case PeriodoConciliadosEnum.DaSemana: return 'desta semana';
      case PeriodoConciliadosEnum.DoMes: return 'do mês';
      case PeriodoConciliadosEnum.Ultimos30Dias: return 'últimos 30 dias';
      case PeriodoConciliadosEnum.DoIntervalo: return 'do intervalo';
      default: return 'do mês';
    }
  }

  selecionarPeriodo(periodo: PeriodoConciliadosEnum): void {
    this.periodoSelecionado = periodo;
    if (periodo !== PeriodoConciliadosEnum.DoIntervalo)
      this.calcularDatasParaPeriodo(periodo);
  }

  private calcularDatasParaPeriodo(periodo: PeriodoConciliadosEnum): void {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    let dataDe: Date;
    let dataAte: Date;

    switch (periodo) {
      case PeriodoConciliadosEnum.Hoje:
        dataDe = new Date(hoje);
        dataAte = new Date(hoje);
        break;
      case PeriodoConciliadosEnum.DaSemana: {
        dataDe = new Date(hoje);
        dataDe.setDate(hoje.getDate() - hoje.getDay());
        dataAte = new Date(dataDe);
        dataAte.setDate(dataDe.getDate() + 6);
        break;
      }
      case PeriodoConciliadosEnum.DoMes: {
        dataDe = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        dataAte = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
        break;
      }
      case PeriodoConciliadosEnum.Ultimos30Dias:
      default: {
        dataDe = new Date(hoje);
        dataDe.setDate(hoje.getDate() - 30);
        dataAte = new Date(hoje);
        break;
      }
    }

    this.model.patchValue({ dataDe, dataAte });
  }

  aplicarPeriodo(trigger?: MatMenuTrigger): void {
    if (this.periodoSelecionado === PeriodoConciliadosEnum.DoIntervalo) {
      this.model.get('dataDe')?.markAsTouched();
      this.model.get('dataAte')?.markAsTouched();

      if (this.model.get('dataAte')?.hasError('dataInvalida')) {
        this.alertService.show('Atenção', 'A data final não pode ser menor que a data inicial.', AlertType.warning);
        return;
      }
      if (this.model.get('dataAte')?.hasError('intervaloExcedido')) {
        this.alertService.show('Atenção', `O intervalo máximo permitido é de ${this.limiteMaxDias} dias.`, AlertType.warning);
        return;
      }
      if (this.model.get('dataDe')?.hasError('required') || this.model.get('dataAte')?.hasError('required')) {
        this.alertService.show('Atenção', 'Preencha as duas datas do intervalo.', AlertType.warning);
        return;
      }
    }

    this.periodoMenuFoiAplicado = true;
    this.salvarPeriodoAplicado();
    this.carregarConciliados(true);
    const menuTrigger = trigger ?? this.periodoMenuTrigger;
    setTimeout(() => menuTrigger?.closeMenu());
  }

  prepararPeriodoIntervalo(): void {
    this.periodoMenuFoiAplicado = false;
  }

  cancelarPeriodoIntervalo(trigger?: MatMenuTrigger): void {
    this.restaurarPeriodoAplicado();
    this.periodoMenuFoiAplicado = true;
    const menuTrigger = trigger ?? this.periodoMenuTrigger;
    setTimeout(() => menuTrigger?.closeMenu());
  }

  onPeriodoMenuClosed(): void {
    if (!this.periodoMenuFoiAplicado)
      this.restaurarPeriodoAplicado();
  }

  private salvarPeriodoAplicado(): void {
    this.periodoSelecionadoAplicado = this.periodoSelecionado;
    this.periodoIntervaloDeAplicado = this.cloneDate(this.model.get('dataDe')?.value);
    this.periodoIntervaloAteAplicado = this.cloneDate(this.model.get('dataAte')?.value);
  }

  private restaurarPeriodoAplicado(): void {
    this.periodoSelecionado = this.periodoSelecionadoAplicado;
    this.model.patchValue({
      dataDe: this.cloneDate(this.periodoIntervaloDeAplicado),
      dataAte: this.cloneDate(this.periodoIntervaloAteAplicado),
    });
  }

  private cloneDate(data: Date | null): Date | null {
    return data ? new Date(data) : null;
  }

  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  // ── Desconciliação ────────────────────────────────────────────────────────

  abrirDesconciliar(row: ConciliadoDisplayRow): void {
    if (row.isChild) return;
    const dialogRef = this.dialog.open(DesconciliarDialogComponent, {
      width: '640px',
      data: { extrato: row.data },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.sucesso) {
        this.alertService.show('Sucesso', 'Lançamento desconciliado com sucesso.', AlertType.success);
        this.carregarConciliados(true);
      }
    });
  }
}
